export const APP_VERSION = 'v1.19.26';
